import { render } from "./StoredResources.vue?vue&type=template&id=7c6c89d4&scoped=true"
import script from "./StoredResources.vue?vue&type=script&lang=js"
export * from "./StoredResources.vue?vue&type=script&lang=js"

import "./StoredResources.vue?vue&type=style&index=0&id=7c6c89d4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6c89d4"]])

export default __exports__